<template>
  <div class="template">
    <QuestionsZoomParams />
    <LoaderFullPage v-if="store.loading" />
    <QuestionsZoomDatas v-else />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import QuestionsZoomParams from "@follaw-fr/components/questions/organisms/QuestionsZoomParams.vue";
import QuestionsZoomDatas from "@follaw-fr/components/questions/organisms/QuestionsZoomDatas.vue";
import { useQuestionsStore } from "@follaw-fr/stores/questions";

const store = useQuestionsStore();
const route = useRoute();

store.fetchOneQuestion(route.params._id);
</script>
